import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { merge } from 'es-toolkit';
import {forkJoin, Observable, of} from 'rxjs';
import {filter, switchMap, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {BaseService} from '../../../../shared/src/lib/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ERService extends BaseService {
  item: any = {};
  meta: any = {};
  currentSearchObj: any;

  incidentsService: BaseService;
  actionsService: BaseService;

  constructor(http: HttpClient) {
    super(`${environment.baseUrl}/er/attributes`, http);
    this.incidentsService = new BaseService(`${environment.baseUrl}/er/incidents`, http);
    this.actionsService = new BaseService(`${environment.baseUrl}/er/actions`, http);
  }

  public loadData(search: any): Observable<any> {
    this.currentSearchObj = search;
    return this.getList(search).pipe(
      // filter(response => response.results.length > 0),
      switchMap(r => forkJoin({
        item: of(r),
        incidents_meta: this.incidentsService.loadMetadata(),
        actions_meta: this.actionsService.loadMetadata()
      })),
      tap(responses => {
        if (responses.item.results[0]) {
          merge(this.item, responses.item.results[0]);
        } else {
          this.item = {};
        }
        merge(this.meta, responses.item.meta);
        this.meta.display_fields = [];
        this.meta.type = 'er/attributes';
        this.meta.urlPath = 'er';
        this.meta.subItems = ['incidents', 'actions'];
        // this.meta.subItems = ['incidents', 'actions', 'attachments'];
        // this.meta.fields.attachments = {'type': 'er/attributesattach'};

        this.meta.fields.incidents = responses.incidents_meta;
        this.meta.fields.incidents.type = 'er/incidents';
        this.meta.fields.incidents.foreign_key_field = 'facility';
        this.meta.fields.incidents.display_fields = ['incident_id', 'incident_date', 'received_by', 'reporting_party', 'reporting_org', 'incident_type', 'material', 'quantity', 'location', 'village', 'srp_name', 'srp_organization', 'details', 'status', 'nrc_number', 'remarks'];
        this.meta.fields.incidents.subItems = ['attachments'];
        this.meta.fields.incidents.attachments = {type: 'er/incidentsattach'};

        this.meta.fields.actions = responses.actions_meta;
        this.meta.fields.actions.type = 'er/actions';
        this.meta.fields.actions.foreign_key_field = 'facility';
        this.meta.fields.actions.display_fields = [
          'incident', 'type', 'issued_date', 'due_date', 'thirty_day_extension', 'received_by_name', 'response',
          'approval', 'approval_date'
        ];
        this.meta.fields.actions.fields.incident.get_choices = () => {
          return new Promise(resolve => {
            this.incidentsService.getList<any>({search: this.item.globalid}).subscribe(response => {
              const choices = response.results.map(item => ({display_name: item.incident_id, value: item.globalid}));
              resolve(choices);
            });
          });
        };

        this.meta.fields.actions.subItems = ['attachments'];
        this.meta.fields.actions.attachments = {type: 'er/actionsattach'};

        this.meta.subItems.forEach(item => {
          this.meta.fields[item].refreshProperties = () => this.refreshTopLevelProperties();
        });
      }));
  }

  private refreshTopLevelProperties() {
    this.getList(this.currentSearchObj).subscribe(response => {
      merge(this.item, response.results[0]);
    });
  }
}
